import React from "react";
import AssetsTable from "../components/assets/tables/AssetsTable";
import { useQuery } from "react-query";

const Assets = () => {
  const API_URL = process.env.REACT_APP_API_URL + "/assets";

  const { data, isLoading, error } = useQuery("assets", async () => {
    const response = await fetch(API_URL, {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${process.env.REACT_APP_API_BEARER_TOKEN}`,
      },
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    const result = await response.json();
    console.log(result, "result");
    return result;
  });

  if (isLoading) {
    return <p>Loading assets...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <div className="container mx-auto">
      <header className="text-center py-8">
        <AssetsTable assets={data} />
      </header>
    </div>
  );
};

export default Assets;
